import {
  Badge,
  Box,
  Button,
  Menu,
  MenuItem,
  Popover,
  SvgIcon,
  Typography,
  styled,
  IconButton,
} from '@mui/material';
import { lightPalette, theme, up } from '../../../theme';

export const classes = {
  root: 'root',
  navbarContainerGrid: 'navbarContainerGrid',
  navbarLeftGrid: 'navbarLeftGrid',
  logoImage: 'logoImage',
  sidebarToggleButtonFromNav: 'sidebarToggleButtonFromNav',
  annotationDocumentNameBox: 'annotationDocumentNameBox',
  IconButtonBackHome: 'IconButtonBackHome',
  navbarRightGrid: 'navbarRightGrid',
  rightMainBox: 'rightMainBox',
  rightMainEndMenuBox: 'rightMainEndMenuBox',
  navbarBoxIconsButtons: 'navbarBoxIconsButtons',
  navbarBoxIcons: 'navbarBoxIcons',
  badge: 'badge',
  notificationMenuIcons: 'notificationMenuIcons',

  avatar: 'avatar',
  profileSettingsMenu: 'profileSettingsMenu',
  profileIcons: 'profileIcons',
  navbarLoader: 'navbarLoader',
  chipBackGround: 'chipBackGround',
};

export const FileIconContainer = styled(Box)(() => ({
  display: 'flex',
  alignItems: 'center',
}));

export const InvoiceNameTypo = styled(Typography)(() => ({
  marginRight: '4vw',
  width: '9vw',
}));

export const StatusDotBox = styled(Box)(() => ({
  height: '5px',
  width: '5px',
  borderRadius: '50%',
}));

export const FileIcon = styled(Box)(() => ({
  color: lightPalette.lunarBase.main,
  marginRight: '0.7vw',
  width: '16px',
  height: '16px',
}));

export const CustomBadge = styled(Badge)(() => ({
  margin: '10px',
  '& .MuiBadge-dot': {
    backgroundColor: lightPalette.lightSilver.main,
  },
}));

export const CustomPurpleBadge = styled(Badge)(() => ({
  margin: '10px',
  '& .MuiBadge-dot': {
    backgroundColor: theme.palette.darkPurple.darkest,
  },
}));

export const CustomRedBadge = styled(Badge)(() => ({
  margin: '10px',
  '& .MuiBadge-dot': {
    backgroundColor: theme.palette.secondaryBlack.medium,
  },
}));

export const DisplayFlexBox = styled(Box)({
  display: 'flex',
});

export const StyledSVGIcon = styled(SvgIcon)({
  fill: 'none',
  [up('xs')]: {
    width: '16px',
    height: '16px',
  },
  [up('md')]: {
    width: '18px',
    height: '18px',
  },
  [up('lg')]: {
    width: '20px',
    height: '20px',
  },
});

export const NotificationMenu = styled(Popover)(() => ({
  position: 'absolute',
  height: '300px',
  [up('xs')]: {
    top: '33px',
  },
}));

export const StyledLoginButton = styled(Button)`
  && {
    box-shadow: none;
    border: 1px solid ${lightPalette.primary.main};
    color: ${lightPalette.primary.main};

    &:hover {
      border: 1px solid ${lightPalette.primary.main};
      color: ${lightPalette.primary.main};
    }
    height: 5vh;
  }
`;

export const ProfileSettingMenu = styled(Menu)(() => ({
  position: 'absolute',
  [up('xs')]: {
    top: '33px',
  },
}));

export const NoMoreNotificationMenu = styled(Menu)(() => ({
  left: '5%',
  height: '150px',
  width: '400px',
  [up('xs')]: {
    top: '33px',
  },
}));

export const NoMoreNotificationMenuItem = styled(MenuItem)(() => ({
  color: lightPalette.shoeWax.semiDark,
  width: '150px',
  display: 'flex',
  justifyContent: 'center',
}));

export const NotificationContentContainer = styled(Box)({
  width: '14vw',
});

export const Width9VWBox = styled(Box)({
  width: '9vw',
});

export const StatusDotContainer = styled(Box)({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  marginLeft: '4vw',
  [up('xs')]: {
    width: '9px',
  },
  [up('sm')]: {
    width: '10x',
  },
  [up('md')]: {
    width: '12px',
  },
  [up('lg')]: {
    width: '14px',
  },
  [up('xl')]: {
    width: '16px',
  },
  [up('xxl')]: {
    width: '18px',
  },
});

export const NotificationFirstRowContainer = styled(Box)({
  display: 'flex',
  alignItems: 'center',
  marginBottom: '5px',
});

export const MenuItemUserName = styled(MenuItem)({
  // cursor: 'auto',
});

export const BoxUserNameAndRole = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
});

export const MenuItemIconButtonUserName = styled(IconButton)({
  cursor: 'auto',
  '&:hover': {
    backgroundColor: 'transparent',
  },
});

export const NotificationAndTimeContainer = styled(Box)({
  display: 'flex',
  alignItems: 'center',
  width: '9vw',
});

export const ExternalLinkIcon = styled(Box)({
  marginLeft: '4vw',
  [up('xs')]: {
    height: '9px',
    width: '9px',
  },
  [up('sm')]: {
    height: '10px',
    width: '10px',
  },
  [up('md')]: {
    height: '12px',
    width: '12px',
  },
  [up('lg')]: {
    height: '14px',
    width: '14px',
  },
  [up('xl')]: {
    height: '16px',
    width: '16px',
  },
  [up('xxl')]: {
    height: '18px',
    width: '18px',
  },
});

export const NotificationListBox = styled(Box)(() => ({
  overflow: 'auto',
  height: '200px',
  scrollbarWidth: 'thin',
  '&::-webkit-scrollbar': {
    width: '0.4em',
  },
  '&::-webkit-scrollbar-track': {
    background: '#D9D9D9',
    borderRadius: '5px',
  },
  '&::-webkit-scrollbar-thumb': {
    backgroundColor: '#868686',
    borderRadius: '5px',
  },
}));

export const ViewAllBox = styled(Box)(() => ({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  background: theme.palette.paperWhite.main,
  cursor: 'pointer',
  [up('xs')]: {
    height: '35px',
  },
  [up('sm')]: {
    height: '40px',
  },
  [up('md')]: {
    height: '45px',
  },
  [up('lg')]: {
    height: '50px',
  },
  [up('xl')]: {
    height: '55px',
  },
  [up('xxl')]: {
    height: '60px',
  },
}));

export const Root = styled('div')(() => ({
  [`&.${classes.root}`]: {},

  [`& .${classes.navbarContainerGrid}`]: {
    height: theme.spacing(6),
    backgroundColor: theme.palette.darkPurple.main,
    // boxShadow: '0px 8px 15px 2px rgba(0, 0, 0, 0.14)',
    position: 'relative',
  },

  [`& .${classes.navbarLeftGrid}`]: {
    paddingLeft: '25px',
    height: '100%',
  },

  [`& .${classes.IconButtonBackHome}`]: {
    height: '30px',
    width: '30px',
    borderRadius: '5px',
    marginRight: '1vw',
    backgroundColor: theme.palette.secondaryWhite.main,
    '&:hover': {
      backgroundColor: theme.palette.secondaryWhite.main,
    },
  },

  [`& .${classes.logoImage}`]: {
    [up('xs')]: {
      height: '20px',
      width: '74px',
    },
    [up('sm')]: {
      height: '24px',
      width: '88px',
    },
  },

  [`& .${classes.sidebarToggleButtonFromNav}`]: {
    background: theme.palette.secondaryWhite.main,
    color: theme.palette.darkPurple.main,
    '&:hover': {
      background: theme.palette.secondaryWhite.main,
      color: theme.palette.primary.main,
    },
    minWidth: '0',
    borderRadius: '4px',
    [up('xs')]: {
      height: '24px',
      width: '24px',
    },
    [up('sm')]: {
      height: '30px',
      width: '30px',
    },
  },

  [`& .${classes.annotationDocumentNameBox}`]: {
    width: '100%',
    height: '100%',
    display: 'flex',
    alignItems: 'center',
  },

  [`& .${classes.navbarRightGrid}`]: {
    paddingRight: '20px',
    height: '100%',
  },

  [`& .${classes.rightMainBox}`]: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    height: '100%',
    width: '100%',
  },

  [`& .${classes.rightMainEndMenuBox}`]: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    height: '100%',
    width: '350px',
  },

  [`& .${classes.navbarBoxIconsButtons}`]: {
    padding: 0,
    color: theme.palette.secondaryWhite.main,
    '& .MuiBadge-badge': {
      [up('xs')]: {
        right: 2,
        top: 3,
        backgroundColor: theme.palette.colorRed.main,
        fontSize: '10px',
      },
      [up('md')]: {
        right: 2,
        top: 3,
        backgroundColor: theme.palette.colorRed.main,
        fontSize: '12px',
      },
    },
  },
  [`& .${classes.navbarBoxIcons}`]: {
    [up('xs')]: {
      height: '18px',
      width: '18px',
    },
    [up('md')]: {
      height: '24px',
      width: '24px',
    },
  },

  [`& .${classes.notificationMenuIcons}`]: {
    [up('xs')]: {
      height: '10px',
      width: '10px',
    },
    [up('sm')]: {
      height: '12px',
      width: '12px',
    },
    [up('md')]: {
      height: '14px',
      width: '14px',
    },
    [up('lg')]: {
      height: '14px',
      width: '14px',
    },
    [up('xl')]: {
      height: '16px',
      width: '16px',
    },
    [up('xxl')]: {
      height: '16px',
      width: '16px',
    },
  },

  [`& .${classes.avatar}`]: {
    backgroundColor: lightPalette.primary.main,
    [up('xs')]: {
      height: '25px',
      width: '25px',
    },
    [up('md')]: {
      height: '35px',
      width: '35px',
    },
  },
  [`& .${classes.profileSettingsMenu}`]: {
    position: 'absolute',
    height: '300px',
    [up('xs')]: {
      top: '32px',
    },
    [up('sm')]: {
      top: '38px',
    },
    [up('md')]: {
      top: '44px',
    },
    [up('lg')]: {
      top: '50px',
    },
    [up('xl')]: {
      top: '54px',
    },
    [up('xxl')]: {
      top: '60px',
    },
  },

  [`& .${classes.profileIcons}`]: {
    [up('xs')]: {
      width: '16px',
      height: '16px',
    },
    [up('md')]: {
      width: '18px',
      height: '18px',
    },
    [up('lg')]: {
      width: '20px',
      height: '20px',
    },
  },
  [`& .${classes.badge}`]: {
    '& .MuiBadge-badge': {
      right: 3,
      top: 3,
      backgroundColor: theme.palette.colorRed.main,
    },
  },
  [`& .${classes.navbarLoader}`]: {
    zIndex: theme.zIndex.drawer + 1,
    color: '#fff',
  },
  [`& .${classes.chipBackGround}`]: {
    backgroundColor: 'rgba(159,119,235, 0.4)',
    border: '1px solid rgba(159,119,235, 1)',
  },
}));
